import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n/index.js';

/**
 * Compact language picker (EN / FR / ES) rendered as a native <select> so it
 * fits the CRM sidebar footer. The browser-language detector persists the
 * choice to localStorage under `i18nextLng`.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const active = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  return (
    <select
      className="lang-switcher"
      aria-label={t('common.language')}
      value={active}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
    >
      {SUPPORTED_LANGUAGES.map((lng) => (
        <option key={lng.code} value={lng.code}>
          {lng.nativeLabel}
        </option>
      ))}
    </select>
  );
}

export default LanguageSwitcher;
